import { Center } from '@mantine/core';
import { Symptom } from 'models/generic';
import { HeartRhythmMeasurement } from 'models/heartRhythm/measurement';
import { getHeartrateValue, getHeartRhythmIndicatorColor } from 'utils/measurement';
import classes from './CalendarBadge.module.css';

interface CalendarBadgeProps {
  item?: HeartRhythmMeasurement;
  onClick: (item: HeartRhythmMeasurement) => void;
}

export const CalendarBadge = ({ item, onClick }: CalendarBadgeProps) => {
  if (!item) return null;
  const { data: itemData } = item;
  if (!itemData) {
    return null;
  }

  const hasSymptoms =
    itemData.context?.symptoms &&
    itemData.context.symptoms.length > 0 &&
    !itemData.context.symptoms.includes(Symptom.NoSymptoms);

  return (
    <Center
      className={`${classes.calendarBadge} ${hasSymptoms && classes.withSymptoms}`}
      bg={getHeartRhythmIndicatorColor(itemData.indicator)}
      w={30}
      h={30}
      onClick={() => onClick(item)}
    >
      {getHeartrateValue(itemData.heartrate, itemData.indicator)}
    </Center>
  );
};
